import { useAuth } from "common/hooks/useAuth";
import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import styled from "styled-components";

import { EMAIL_ADMINS_FOR_PERMISSIONS } from "common/actions/users";
import { AdminsList } from "common/components/admins";
import { PrimaryButton } from "common/components/buttons/button";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";

export const NoPermissions = function({ admins }) {
    const [requestedAccess, setRequestedAccess] = useState(false);
    const { logout } = useAuth();
    const userRef = useSelector((state) => state.common.user._id);
    const auth_info = useSelector((state) => state.authentication.auth_info, shallowEqual);
    
    const sendEmail = () => {
        EMAIL_ADMINS_FOR_PERMISSIONS(userRef).then((b) => {
            if (b) {
                setRequestedAccess(true);
            }
            
            return b;
        });
    };
    
    const getButtonTitle = () => (!requestedAccess ? <span>Request access</span> : <span><FontAwesomeIcon className="request-access" icon={faCheck}/>Access request sent</span>);
    
    const getInternalSupportContact = () => {
        if (auth_info.sso === "worldpay") {
            return (
                <div className="no-admins">
                    Admins assign permissions, but your organization does not have an admin. <br/>
                    Contact your Worldpay representative to add an admin via the Service Portal.
                </div>
            );
        }
        return (
            <div className="no-admins">
                Admins assign permissions, but your organization does not have an admin.  Contact Pazien to assign an admin and enable access.
                <div className="btn-container">
                    <PrimaryButton onClick={sendEmail} style={{ width: 200 }}>{getButtonTitle()}</PrimaryButton>
                </div>
            </div>
        );
    };
    
    const renderContactInfo = () => {
        if (admins.length) {
            return (
                <>
                    <div className="no-permissions-msg">
                        The following admins can enable access
                    </div>
                    <AdminsList data={admins} />
                    <div className="btn-container">
                        <PrimaryButton onClick={sendEmail} style={{ width: 200 }}>{getButtonTitle()}</PrimaryButton>
                    </div>
                </>
            );
        }
        
        return getInternalSupportContact();
    };
    
    return (
        <NoPermissionsStyled>
            <div className="no-permissions-header">
                Your account does not have user permissions assigned.
            </div>
            {renderContactInfo(admins)}
            <div className="logout-wrap">
                <a href="#" className="logout" onClick={(e) => { e.preventDefault(); logout(); }}>Return to sign in</a>
            </div>
        </NoPermissionsStyled>
    );
};

const NoPermissionsStyled = styled.div`
    min-height: 220px;
    text-align: center;

    .no-permissions-header {
        font-size: ${(props) => props.theme.headerFontSize};
        font-family: ${(props) => props.theme.text.medium};
        padding: 5px;
    }

    .no-permissions-msg {
        font-size: ${(props) => props.theme.fontSizeExtraLarge};
        font-family: ${(props) => props.theme.text.medium};
        padding: 5px;
    }

    .admin-list {
        margin-top: 20px;

        ul {
            margin: auto;
            width: 480px;

            li {
                div.admin {
                    display: flex;
                    justify-content: space-between;

                    div {
                        position: relative;
                        display: inline-block;
                        padding: 2px 0;
                        font-size: ${(props) => props.theme.fontSizeExtraLarge};
                        font-family: ${(props) => props.theme.text.regular};
                        text-align: left;
                        width: 240px;
                    }
                }

            }
        }
    }

    .btn-container {
        text-align: center;
        margin: 25px auto;
    }

    .no-admins {
        margin: 40px 0;

        .btn-container {
            margin: 40px 0 0 0;
        }
    }

    .logout-wrap {
        margin-top: 10px;
        text-align: center;
        font-size: ${(props) => props.theme.fontSizeLarge};
        font-family: ${(props) => props.theme.text.regular};
    }
`;
